/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'

/** Common Components */
import UnderConstruction from '../../../../components/ui/underConstruction/UnderConstruction'

/**Wrapped Component */
import Financial from '../../Financial'

const GPIntegration = () => {

  return (
 
      <UnderConstruction />
   
  )
}
export default Financial(GPIntegration)